export default __webpack_public_path__ + "static/landingbg-d90a2ea56f95c3da9a67975f3f0b2c71.mp4";